export default {
    SET_BALANCE_HISTORIES: (state, balanceHistories) => {
        state.balanceHistories = balanceHistories
    },

    ADD_TO_BALANCE_HISTORIES: (state, balanceHistory) => {
        state.balanceHistories.unshift(balanceHistory)
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    },

    SET_TO_DATE: (state, toDate) => {
        state.date.toDate = toDate
    },

    SET_FROM_DATE: (state, fromDate) => {
        state.date.fromDate = fromDate
    },

    SET_CLIENT_ID: (state, clientId) => {
        state.filters.clientId = clientId
    },

    SET_TAXI_ORDER_ID: (state, taxiOrderId) => {
        state.filters.taxiOrderId = taxiOrderId
    },

    SET_PAYMENT_ID: (state, paymentId) => {
        state.filters.paymentId = paymentId
    },

    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },

    RESET_BALANCE_HISTORIES: (state) => {
        state.filters = {
            fromDate: new Date(+new Date() - 2419200000).toISOString().split('T')[0],
            toDate: new Date().toISOString().split('T')[0],
            clientId: null,
            taxiOrderId: null,
            paymentId: null,
            paymentType: null,
            orderType: null,
            phoneNumber: null
        }
    }
}
